import PropTypes from "prop-types";
import React, { useState } from "react";
import SignupForm from "./SignupForm";
import LoginForm from "./LoginForm";
// import SignupPrompt from "./SignupPrompt/SignupPrompt";
import { useFeatureFlags } from "../../hooks";

const FormTypes = {
  SIGNUP: "signup",
  LOGIN: "login"
};

const AuthForm = ({
  focus,
  formType,
  fullScreen,
  msg,
  nextUrl,
  notice,
  subtitle,
  title,
  login = false
}) => {
  const featureflags = useFeatureFlags();

  const [formName, setFormName] = useState(
    login ? FormTypes.LOGIN : FormTypes.SIGNUP
  );

  const toggleForm = () =>
    setFormName(
      formName === FormTypes.LOGIN ? FormTypes.SIGNUP : FormTypes.LOGIN
    );

  const form =
    formName === FormTypes.SIGNUP ? (
      <SignupForm
        focus={focus}
        formType={formType}
        nextUrl={nextUrl}
        subtitle={subtitle}
        title={title}
        toggleForm={toggleForm}
      />
    ) : (
      <LoginForm
        focus={focus}
        msg={msg}
        nextUrl={nextUrl}
        notice={notice}
        toggleForm={toggleForm}
      />
    );

  if (fullScreen) {
    if (featureflags?.NEW_SIGNUP_UI) {
      return (
        <div className="authentication-wrapper">
          <h1>Steven is here</h1>
          {/* <SignupPrompt /> */}
        </div>
      );
    } else {
      return (
        <div className="authentication-wrapper signup-modal full-screen-prompt">
          <div className="auth-form-full-screen">{form}</div>
        </div>
      );
    }
  } else {
    return form;
  }
};

AuthForm.propTypes = {
  focus: PropTypes.bool,
  formType: PropTypes.string,
  fullScreen: PropTypes.bool,
  login: PropTypes.bool,
  msg: PropTypes.string,
  nextUrl: PropTypes.string,
  notice: PropTypes.string,
  signup: PropTypes.bool,
  signupFrom: PropTypes.string,
  subtitle: PropTypes.string,
  title: PropTypes.string
};

export default AuthForm;
